import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PublicShell from '../components/PublicShell';
import { authAPI } from '../services/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!token) {
      setError('Kein gültiger Reset-Link. Bitte erneut anfordern.');
      return;
    }
    if (newPassword.length < 6) {
      setError('Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.resetPassword(token, newPassword);
      setMessage(res.message || 'Passwort gesetzt.');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.response?.data?.message || 'Passwort konnte nicht gesetzt werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicShell narrow>
      <div className="auth-card">
        <span className="t12-badge">Tippspiel</span>
        <h1 className="section-title text-2xl md:text-3xl mb-1">Neues Passwort</h1>
        {!token && (
          <p className="text-sm text-amber-200/90 mb-4">
            Link unvollständig. Bitte die E-Mail erneut anfordern.
          </p>
        )}
        {message && <div className="alert-success-dark mb-4">{message}</div>}
        {error && <div className="alert-error-dark mb-4">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label-dark" htmlFor="newPassword">Neues Passwort</label>
            <input
              id="newPassword"
              type="password"
              className="input-dark"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={6}
              required
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="label-dark" htmlFor="confirmPassword">Passwort bestätigen</label>
            <input
              id="confirmPassword"
              type="password"
              className="input-dark"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={6}
              required
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn-wacker w-full" disabled={loading || !token}>
            {loading ? 'Speichern…' : 'Passwort speichern'}
          </button>
        </form>
        <p className="text-center text-sm mt-6 text-white/50">
          {message ? (
            <Link to="/login" className="text-primary-light hover:underline font-semibold">Zur Anmeldung</Link>
          ) : (
            <Link to="/passwort-vergessen" className="text-primary-light hover:underline font-semibold">Link erneut anfordern</Link>
          )}
        </p>
      </div>
    </PublicShell>
  );
};

export default ResetPassword;
